{
  "auth": {
    "welcome": "welcome to the otherverse",
    "loginSubtitle": "Enter your credentials to certify",
    "usernameLabel": "Username or email",
    "usernamePlaceholder": "Enter your username or email...",
    "passwordLabel": "Password",
    "certifyButton": "Certify",
    "forgotPasswordLink": "Forgot your username or password?",
    "forgotPasswordTitle": "Recover access",
    "forgotPasswordSubtitle": "Enter your username or email and we'll send you a link to choose a new password.",
    "forgotPasswordSent": "If the account exists, we sent you an email with instructions.",
    "forgotPasswordCooldownTimer": "You can request it again in {{time}}.",
    "resetPasswordTitle": "Choose a new password",
    "resetPasswordSubtitle": "Enter a new password for your Colonny account.",
    "resetPasswordSubmit": "Save password",
    "resetPasswordSuccess": "Your password was updated successfully. You can now log in with it.",
    "resetPasswordNoToken": "This link isn't valid. Request a new one from the login screen.",
    "resetPasswordNewPasswordPlaceholder": "Minimum 8 characters...",
    "resetPasswordTooShort": "The password must be at least 8 characters.",
    "resetPasswordMismatch": "The passwords don't match.",
    "resetPasswordError": "Error connecting to the server.",
    "forgotPasswordIdentifierLabel": "Username or email",
    "forgotPasswordIdentifierPlaceholder": "Enter your username or email...",
    "forgotPasswordSubmit": "Send",
    "forgotPasswordSending": "Sending...",
    "backToLogin": "Back to login",
    "onboardingPasswordTitle": "Set your password",
    "onboardingPasswordSubtitle": "Secure your account to continue",
    "newPasswordLabel": "New Password",
    "newPasswordPlaceholder": "Minimum 4 characters...",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Re-type your password...",
    "nextButton": "Next",
    "nickLabel": "Choose your nickname",
    "nickPlaceholder": "Your display name...",
    "emailLabel": "Enter your email",
    "emailPlaceholder": "user@domain.com",
    "nickTaken": "nickname already taken",
    "emailTaken": "email taken / error",
    "profileCompletionTitle": "Complete your profile",
    "profileCompletionSubtitle": "Tell us a bit about yourself",
    "descriptionLabel": "Description (Max 350)",
    "descriptionPlaceholder": "Tell us something short about you...",
    "locationLabel": "Location",
    "locationPlaceholder": "Your city, country...",
    "religionLabel": "Religion",
    "religionPlaceholder": "Optional...",
    "birthDateLabel": "Date of birth",
    "documentationTitle": "Documentation",
    "documentationSubtitle": "Upload your documents to verify your identity",
    "documentationRequired": "All documents except RFC are required",
    "idFront": "ID Front",
    "idBack": "ID Back",
    "proofOfAddress": "Proof of address",
    "curp": "CURP",
    "birthCertificate": "Birth certificate",
    "rfcLabel": "RFC (Optional)",
    "startAdventureButton": "Start Adventure",
    "addProfilePhoto": "Add profile photo",
    "addProfilePhotoHint": "(Click or Drag)"
  },
  "nav": {
    "home": "Home",
    "docs": "Docs",
    "database": "Database",
    "calendar": "Calendar",
    "tasks": "Tasks",
    "profile": "Profile",
    "logout": "Log Out",
    "allSpaces": "All spaces"
  },
  "common": {
    "language": "Language",
    "timezone": "Timezone",
    "timezoneSelectPlaceholder": "Select a timezone",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "loading": "Loading...",
    "noResults": "No results",
    "confirm": "Confirm",
    "close": "Close",
    "onlyMine": "Only my tasks",
    "allItems": "All tasks",
    "onlyMineTooltipOn": "Showing only your tasks and events — click to see everyone's",
    "onlyMineTooltipOff": "Showing everyone's tasks and events — click to see only yours",
    "noDate": "No date"
  },
  "relativeDate": {
    "today": "today",
    "tomorrow": "tomorrow",
    "inDays": "in {{count}} days",
    "yesterday": "yesterday",
    "twoDaysAgo": "two days ago",
    "daysAgo": "{{count}} days ago",
    "oneWeekAgo": "a week ago",
    "twoWeeksAgo": "two weeks ago",
    "threeWeeksAgo": "three weeks ago",
    "fourWeeksAgo": "four weeks ago",
    "oneMonthAgo": "a month ago",
    "monthsAgo": "months ago"
  }
}
